import dayjs from 'dayjs';
import _ from 'lodash';

export function objectTransenum<T extends { [key: string]: string }>(object: T) {
    if (!object) {
        return []
    }
    return Object.keys(object).map(key => ({ name: object[key], value: key }))
}

export function disabledBetweenDate({ isStart, startKey, endKey }, formData) {
    let start = _.get(formData, startKey);
    let end = _.get(formData, endKey);

    if (!isStart && start) {
        return {
            disabledDate: (current) => {
                return current && current.isBefore(dayjs(start))
            }
        }
    }
    if (isStart && end) {
        return {
            disabledDate: (current) => {
                return current && current.isAfter(dayjs(end))
            }
        }
    }
    return {};
}


/**
 * 禁用开始日期和结束日期之间的日期
 * @param startDate 开始日期
 * @param endDate 结束日期
 * @returns 禁用日期
 */
export function disabledBetweenDateValues({ startDate, endDate }: { startDate?: string, endDate?: string }) {
    return {
        disabledDate: (current) => {
            const disabledStart = startDate && current && current.isBefore(dayjs(startDate));
            const disabledEnd = endDate && current && current.isAfter(dayjs(endDate));
            return disabledStart || disabledEnd;
        }
    }
}


// 金额转数字
export function budgetToNumber(budget?: string | number) {
    if (typeof budget === 'number') {
        return budget
    }
    // undefined, null, ''
    if (!budget) return '';
    return Number(budget.replace(/[^0-9.]/g, ''))
}
